// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3EDSt","title":"BackImages_title__2eqdH","images":"BackImages_images__2mIZV"};